import type { IInventoryItem } from 'src/api/getInventory/types';

import { InventoryItemType } from 'src/types/inventory.types';
import { formatDate } from '../../../helpers/formatDate/formatDate';
import { formatTime } from '../../../helpers/formatTime/formatTime';

export type TInventoryRow = {
  id: string;
  code?: string | null;
  name: string;
  type: InventoryItemType;
  allergens: string;
  calories: string | undefined;
  ingredients: string | undefined;
  claims: string;
  updatedAt: string;
};

export const mapInventoryToTable = (items: IInventoryItem[]): TInventoryRow[] => {
  return items.map((item) => ({
    id: item.recipe_id,
    name: item.name,
    code: item.code,
    type: item.type,
    allergens: item.allergens_information
      .map((allergen) => {
        const childAllergens = allergen.child_allergens
          ? ` (${allergen.child_allergens.map((a) => a.name).join(', ')})`
          : '';
        return `${allergen.name}${childAllergens}`;
      })
      .join(', '),
    calories: item.nutritional_information
      .filter((nutrition) => nutrition.name === 'energy_kcal' || nutrition.name === 'energy')
      .map((nutrition) => {
        const valueLow = Math.round(nutrition.value_low);
        const valueHigh = Math.round(nutrition.value_high);
        return valueHigh === valueLow ? valueHigh : `${valueLow} - ${valueHigh}`;
      })[0]
      ?.toString(),
    ingredients: item.description,
    claims: `${['contains_alcohol', 'is_vegan', 'is_vegetarian']
      .filter((key) => item[key])
      .map((key) => key.split('_')[1])
      .join(' ')} `,
    updatedAt: `${formatDate(new Date(item.update_date))}, ${formatTime(new Date(item.update_date))}`,
  }));
};
